import React, { useState, useEffect } from "react";
import { Button, Typography, Grid } from "@material-ui/core";
import style from "./HOD.module.css";

const HOD = () => {
  const [hod, setHOD] = useState({});
  const categories = ["health", "business", "entertainment", "science"];
  const randomCategory = Math.floor(Math.random() * categories.length);
  const randomArticle = Math.floor(Math.random() * 10);
  const URL = `https://free-news.p.rapidapi.com/v1/search?q=${categories[randomCategory]}&lang=en&country=IN&topic=news&page_size=20`;
  const config = {
    method: "GET",
    headers: {
      "x-rapidapi-key": process.env.REACT_APP_X_RAPIDAPI_KEY,
      "x-rapidapi-host": process.env.REACT_APP_X_RAPIDAPI_HOST,
    },
  };

  const fetchHOD = async () => {
    const response = await fetch(URL, config);
    const data = await response.json();
    setHOD(data.articles[randomArticle]);
  };

  useEffect(() => {
    fetchHOD();
  }, []);

  return (
    <section>
      <h1 className={style.heading}>Treding headline of the day</h1>
      <Grid
        container
        className={style.hod}
        direction="row"
        justify="space-between"
      >
        <Grid item className={style.imageBox} md={12} lg={5}>
          <img
            src={
              hod.media ||
              "https://media.istockphoto.com/vectors/male-hand-holding-megaphone-with-breaking-news-speech-bubble-banner-vector-id1197831888?k=6&m=1197831888&s=612x612&w=0&h=VJvkLPJQ3k3xhN16Y-g7dAGqxmWOHfPkteHwtjYlTSc="
            }
            alt="Top-headlines"
          />
        </Grid>
        <Grid
          container
          direction="row"
          justify="space-around"
          item
          className={style.contentBox}
          md={12}
          lg={6}
        >
          <Grid item xs={12}>
            <Typography variant="h5" gutterBottom className={style.title}>
              {hod.title}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="body2"
              component="h2"
              color="textSecondary"
              className={style.description}
            >
              {hod.summary}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              href={hod.link}
              target="_blank"
              className={style.button}
            >
              Show More
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </section>
  );
};

export default HOD;
